import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for client-side navigation
import logo from '../../Assets/img/Neoin-logo.png'
import axios from 'axios';
import { useQuantityContext } from '../QuantityContext';
import PreviewFileItem, { PreviewImage } from '../Utilities/PreviewFileItem';
import { Avatar } from '@material-ui/core';
// import { display } from 'html2canvas/dist/types/css/property-descriptors/display';

function VerificationFile({ token, action, requestId }) {
    const [status, setStatus] = useState('accept');
    const [comment, setComment] = useState('');
    const [closeTab, setCloseTab] = useState(false);
    const [studentData, setStudentData] = useState();
    const navigate = useNavigate(); // Initialize useNavigate hook for navigation
    const { handleSuccess, handleFailure } = useQuantityContext();
    // Function to handle both accept and reject actions

    const [sectionData, setSectionData] = useState({});

    useEffect(() => {
        if (studentData) {
            setSectionData({
                fullName: studentData?.userData?.fullName,
                educationLevel: studentData?.cardData?.education_level,
                institute: studentData?.cardData?.institute,
                board: studentData?.cardData?.board,
                studentId: studentData?.cardData?.student_id,
                grade: studentData?.cardData?.grade,
                degree: studentData?.cardData?.degree,
                fieldOfStudy: studentData?.cardData?.field_of_study,
                // isCurrent: studentData?.cardData?.is_pursuing ?? false,
                duration: studentData?.cardData?.student_currently_pursuing
                    ? studentData?.cardData?.student_starting_year + " - Present"
                    : studentData?.cardData?.student_starting_year + " - " + studentData?.cardData?.student_ending_year,
            });
        }
    }, [studentData]);

    useEffect(() => {
        const fetchData = async () => {
            const config = {
                params: {
                    requestId,
                },
                headers: {
                    "x-api-key": process.env.REACT_APP_API_KEY,
                    Authorization: `Bearer ${process.env.REACT_APP_AUTH_TOKEN}`,
                    "Content-Type": "application/json",
                },
            };

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/adminverify/get-card-verification-data`,
                    config
                );
                console.log("Response:", response.data);
                if (response?.data?.statusCode === 200) {
                    setStudentData(response?.data?.data);
                }

            } catch (error) {
                console.error("API error", error);
            }
        };

        fetchData();
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();

        // Build API URL with the token, requestId, status, and comment
        const url = `${process.env.REACT_APP_BACKEND_URL}/adminverify/student-response?token=${token}&requestId=${requestId}&action=${status}&comment=${comment}`;

        const config = {
            headers: {
                'x-api-key': 'secret_api_key_123456',
                'Authorization': `Bearer ${token}`, // Use the provided token
                'Content-Type': 'application/json',
            },
        };

        try {
            const response = await axios.get(url, {}, config);
            console.log("res", response);

            if (response.data.status === "SUCCESS") {
                // alert("Verification is completed");
                handleSuccess("Verification is completed");

                setCloseTab(true);
                // Redirect to the main page after successful submission
                // navigate('/home'); // Replace '/main' with the route for the main page
            }
        } catch (error) {
            // alert(`There was a problem with the request: ${error.message}`);
            handleFailure("There was a problem with the request ", `${error.message}`)
        }
    };

    // Handle cancel action: reject the request and reset the form
    const handleCancel = async () => {
        setStatus('reject');
        setComment('');

        // Build API URL with reject status
        const url = `${process.env.REACT_APP_BACKEND_URL}/adminverify/student-response?token=${token}&requestId=${requestId}&action=reject&comment=${comment}`;

        const config = {
            headers: {
                'x-api-key': 'secret_api_key_123456',
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        };

        try {
            const response = await axios.get(url, {}, config);
            console.log("res", response);

            if (response.data.status === "SUCCESS") {
                handleFailure("Request rejected");

                // Redirect to the main page after rejection
                // navigate('/home'); // Replace '/main' with the route for the main page
            }
        } catch (error) {
            handleFailure(`There was a problem with the request: ${error.message}`);
        }
    };

    const renderSectionData = () => {
        return Object.keys(sectionData)?.map((key, index) => {
            const value = sectionData[key];
            if (!value) return null;

            const formattedLabel = key
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, (str) => str.toUpperCase());

            return (
                <div key={key} style={styles.infoTable} className="word-break">
                    <div key={`label-${index}`} style={styles.label}>
                        {formattedLabel}
                    </div>
                    <div key={`value-${index}`} style={styles.value}>
                        : <span className="ps-1"> {value} </span>
                    </div>
                </div>
            );
        });
    };

    return (
        <>
            {!closeTab ?
                <div style={styles.parent}>
                    <div style={styles.cardOuter}>
                        <h4 className="text-center">Student Details</h4>
                        <div className="flex-center">

                            {studentData?.userData?.profilePicture ?
                                <div style={styles.imgContainer}> <img
                                    src={studentData?.userData?.profilePicture}
                                    alt="Profile"
                                    className="cover-image"
                                />
                                </div> : <Avatar
                                    src="/broken-image.jpg"
                                    style={{ height: "100px", width: "100px" }}
                                />}


                        </div>

                        {renderSectionData()}
                        {studentData?.verificationData?.attachmentUrls?.length > 0 && (
                            <div className="px-3">
                                <div className="my-2 fw-bold">Attachments</div>
                                <div className="d-flex flex-wrap gap-4 align-items-center">
                                    {studentData?.verificationData?.attachmentUrls?.map((attachment, index) =>
                                        attachment?.type.startsWith("image/") ? (
                                            <div key={index}>
                                                <PreviewImage file={attachment} displaySize="80px" />
                                            </div>
                                        ) : null
                                    )}
                                </div>
                                <div className="d-flex justify-content-center align-items-start flex-column">
                                    {studentData?.verificationData?.attachmentUrls?.map((attachment, index) =>
                                        !attachment?.type.startsWith("image/") ? (
                                            <div key={index} className="mb-3 w-100">
                                                <PreviewFileItem file={attachment} fontColor="#00000099" />
                                            </div>
                                        ) : null
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div style={styles.topcontainer}>
                        < div style={styles.container} >
                            <div style={styles.header}>
                                <img src={logo} alt="NEOIN logo" style={styles.logo} />
                                <h2>Student Verification Request</h2>
                            </div>

                            One of your college / university student has initiated a request to verify their student details.
                            Please note that upon verification, a notification will be sent to the student confirming the verification.

                            < form onSubmit={handleSubmit} >
                                <div style={styles.radioGroup}>
                                    <label style={styles.radioGrouplabel}>
                                        <input
                                            type="radio"
                                            name="status"
                                            value="accept"
                                            checked={status === 'accept'}
                                            onChange={() => setStatus('accept')}
                                        />
                                        Approved
                                    </label>
                                    <label style={styles.radioGrouplabel}>
                                        <input
                                            type="radio"
                                            name="status"
                                            value="reject"
                                            onChange={() => setStatus('reject')}
                                        />
                                        Rejected
                                    </label>
                                </div>
                                <textarea
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                    placeholder="Comment here"
                                    style={styles.textarea}
                                />
                                <div style={styles.buttons}>
                                    <button type="button" onClick={handleCancel} style={styles.cancelButton}>
                                        CANCEL
                                    </button>
                                    <button type="submit" style={styles.submitButton}>
                                        SUBMIT
                                    </button>
                                </div>
                            </form >
                        </div >
                    </div>
                </div>
                :
                <div style={styles.topcontainer}>
                    <div style={styles.container}>
                        <div style={styles.header}>
                            <img src={logo} alt="NEOIN logo" style={styles.logo} />
                            <h2>Student Verification Request</h2>
                        </div>

                        One of your college/university student has initiated a request to verify their student details.
                        Please note that upon verification, a notification will be sent to the student confirming the verification.

                    </div>
                </div>
            }
        </>
    );
}

const styles = {
    topcontainer: {
        display: "flex",
        height: "100%",
        justifyContent: 'center',
        alignItem: 'center'
    },
    container: {
        // dispaly: "flex",
        maxWidth: '600px',
        margin: 'auto',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        // height: "100%"
    },
    parent: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        gap: "16px",
        padding: "32px",
        flexWrap: "wrap-reverse",
    },
    cardOuter: {
        borderRadius: "8px",
        padding: "16px",
        minWidth: "300px",
        width: "auto",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)"
    },
    infoTable: {
        marginTop: "8px",
        display: "grid",
        gridTemplateColumns: "150px 1fr", // Two columns: label and value
        rowGap: "8px",
        alignItems: "center",
        color: "rgb(0, 0, 0, 87%)",
        padding: "0 16px",
    },
    label: {
        fontWeight: "bold",
        justifySelf: "start", // Align labels to the end
        paddingRight: "8px", // Add space for the colon alignment
    },
    value: {
        justifySelf: "start", // Align values to the start
        // maxWidth: "150px", // Restrict width
        whiteSpace: "nowrap", // Prevent text wrapping
        overflow: "hidden", // Hide overflow
        textOverflow: "ellipsis", // Add ellipsis for overflow text
    },
    header: {
        marginBottom: '20px',
    },
    logo: {
        width: '100px',
        marginBottom: '10px',
    },
    radioGroup: {
        display: 'flex',
        justifyContent: 'start',
        marginBottom: '20px',
    },
    textarea: {
        width: '100%',
        height: '100px',
        marginBottom: '20px',
        padding: '10px',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'right',
    },
    cancelButton: {
        backgroundColor: 'transparent',
        border: 'none',
        color: '#007BFF',
        cursor: 'pointer',
        marginRight: '20px'
    },
    submitButton: {
        border: 'none',
        color: '#fff',
        padding: '10px 20px',
        borderRadius: '4px',
        cursor: 'pointer',
        background: 'var(--Primary-Color, #0044C6)',
    },
    radioGrouplabel: {
        margin: '10px'
    },



    imgContainer: {
        height: "110px",
        width: "110px",
        borderRadius: "50%",
        overflow: "hidden",
        border: "2px solid #DCDCDC88",
        marginBottom: "8px",
    },
};

export default VerificationFile;
